import { render, staticRenderFns } from "./ProcedureManage.vue?vue&type=template&id=fb5236a4&scoped=true&"
import script from "./ProcedureManage.vue?vue&type=script&lang=js&"
export * from "./ProcedureManage.vue?vue&type=script&lang=js&"
import style0 from "./ProcedureManage.vue?vue&type=style&index=0&id=fb5236a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb5236a4",
  null
  
)

export default component.exports